import TemplateView from '../../../TemplateView'
import {DemoDataStageType} from '../constants'
import ClassicBridge from '../../../next/ClassicBridge'
import $ from "../../../alias/jquery";

export default class DemoDataComponent extends TemplateView {

    constructor() {
        super()
        this.state = {
            stage: DemoDataStageType.ACTIVE,
        }

        this.onStatePropertyChanged('stage', stage => this.refreshStage(stage))
    }

    refreshStage(stage) {
        if (stage !== DemoDataStageType.ACTIVE) {
            clearTimeout(this.progressTimer)
        }

        this.actualProgress = stage === DemoDataStageType.COMPLETED ? 100 : 0

        if (stage === DemoDataStageType.ACTIVE) {
            this.startDemoLoadingProgress()
        } else {
            this.renderProgress()
        }
    }

    startDemoLoadingProgress() {
        const baseTimeOut = 200
        const baseStep = 2
        const increaseProgress = () => {
            this.renderProgress()
            // increase percent value from 0 to 95
            if (this.actualProgress < 95) {
                this.actualProgress += Math.round(baseStep + Math.random() * baseStep);
                this.progressTimer = setTimeout(increaseProgress, baseTimeOut + Math.random() * baseTimeOut);
            }
        };
        increaseProgress();
    }

    templateHtml() {
        return '<div></div>'
    }

    renderProgress() {
        if (this.progress) {
            this.progress.setProps({progress: this.actualProgress})
        }
    }

    show() {
        this.progress = ClassicBridge.integrateProgressFullscreenSpinner(this.$progressContainer[0], {
            className: 'fullscreenSpinnerZindex',
            progress: this.actualProgress,
            label: window.messageResource.getMessage('welcome_screen.demo.progress')
        })
        super.show()
    }

    hide() {
        if (this.progress) {
            this.progress.remove()
        }
        this.$progressContainer.remove()
        super.hide()
    }

    afterRender() {
        this.actualProgress = 0
        // TODO it's required for ClassicBridge.integrateProgressFullscreenSpinner component (probably should be a part of the component)
        this.$progressContainer = $('<div/>').addClass('atNextMount atNextOverlays').appendTo($('body'))
    }
}


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/components/DemoDataComponent.js